<template>
    <div class="twoBannerHome wow fadeInAnimated fadeIn">
        <div class="title">
            <img :src="haojobLogo" alt="" class="haojobImg" @click="goHome" style="cursor:pointer;">
            <span class="selectCity" @click="goSelectCity()">全国站></span>
            <ul class="tabItem">
                <li @click="goHome" :class="!appTrueActive?'active':''">首页</li>
                <li @click="$router.push('/investment')">招商加盟</li>
                <li @mouseenter="appDownload"  @mouseleave="leaveDownload" :class="appTrueActive?'active':''">APP下载</li>
                <li @click="$router.push('/relationPages')">联系我们</li>
                <li style="width: 100px;height: 35px;background: #FFFFFF;border: 1px solid #1D5EEA;line-height:35px;text-align: center;margin-top:22.5px;padding:0;"><a style="color:#1D5EEA;text-decoration: none;" href="http://consoletwo.lielanghr.com/#/login">劳务登录</a></li>
            </ul>
        </div>
        <downloadApp v-if="appTrueActive"></downloadApp>
        <div class="centerFloat">
            <div class="header">
                <div class="headerCont">
                    <img :src="headTitBg" alt="" class="headTitBg">
                    <img :src="headLogoBg" alt="" class="headLogoBg">
                    <div class="preempt">抢占先机  |  居家服务 |  轻松拓客 |  锁定收益</div>
                    <span class="atOnce" @click="goEnter">立即入驻</span>
                </div>
            </div>
            <div class="textCont">
               <div class="hotJobTit">
                   <span></span>
                   <p>全国职位</p>
                   <span></span>
               </div>
               <ul class="jobList">
                   <li class="jobListLi" v-for="(item,index) in jobList" :key="index" @click="jobShowDetail(item.jobId)">
                       <div class="jobListLiHead"> 
                           <span class="jobListLiHeadTitle">{{item.jobName}}</span>
                           <span class="jobListLiHeadMoney" v-if="item.userHourSalary">{{item.userHourSalary}}元/小时</span>
                           <span class="jobListLiHeadMoney" v-else>{{item.userMinSalary}}-{{item.userMaxSalary}}元/月</span>
                       </div>
                       <div class="jobLiAge">{{item.jobType}} | {{item.factoryTypeName}}</div>
                       <div class="jobLiLabel">
                           <span v-for="(label,index) in JSON.parse(item.welfareTag)" :key="index">
                               {{label}}
                           </span>
                       </div>
                       <div class="jobLiFoot">
                           <span class="jobLiCom">{{item.factoryAbbreviationName}}</span>
                           <img :src="locationImg" alt="" class="jobLiLoca">
                           <span class="jobLiCity">{{addressCity(item.provinces)}}</span>
                       </div>
                   </li>
               </ul>
               <div class="seeMore" v-if="jobListTrue" @click="seeMoreJob">查看更多</div>
            </div>
            <div class="textCont">
                <div class="hotJobTit">
                    <span></span>
                    <p>全国企业</p>
                    <span></span>
                </div>
                <ul class="companyList">
                    <li class="companyListLi" v-for="(item,index) in companyList" :key="index">
                        <img :src="item.iconUrl" alt="" class="companyListLiImg">
                        <span class="companyListLiName">{{item.abbreviationName}}</span>
                        <span class="companyListLiNum">{{item.status}} · {{item.scale}}</span>
                    </li>
                </ul>
                <div class="seeMore" v-if="comSeeMore" @click="seeMoreCom">查看更多</div>
            </div>
            <!-- 城市合伙人 -->
            <div class="textCont">
                <div class="hotJobTit">
                    <span></span>
                    <p>全国城市合伙人</p>
                    <span></span>
                </div>
                <ul class="partnerList">
                    <li class="partnerListLi" v-for="(item,index) in groupWebList" :key="index" @click="goLabourDetail(item)">
                        <img :src="item.iconUrl" alt="" class="partnerListLiImg">
                        <span class="partnerOne">{{item.groupAbbreviationName}}</span>
                        <span class="partnerTwo">{{item.groupManagerName | userName}} {{item.groupManagerPhone | phone}}</span>
                        <span class="partnerThree">{{item.cityName}} · {{item.citySum || 0}}个街道</span>
                        <span class="partnerFour">
                            <span class="numLi">
                                <span>{{item.storeSum || 0}}</span>
                                <span>门店数量</span>
                            </span>
                            <span class="numLi">
                                <span>{{item.storeUserSum || 0}}</span>
                                <span>专员数量</span>
                            </span>
                            <span class="numLi">
                                <span>{{item.userSum || 0}}</span>
                                <span>会员数量</span>
                            </span>
                        </span>
                    </li>
                </ul>
                <div class="seeMore" v-if="groupSeeMore" @click="groupMoreCom">查看更多</div>
            </div>
            <!-- 全国人才 -->
            <div class="textCont">
                <div class="hotJobTit">
                    <span></span>
                    <p>全国人才</p>
                    <span></span>
                </div>
                <ul class="talentsList">
                    <li class="talentsListLi" v-for="(item,index) in userList" :key="index">
                        <img :src="item.headImgUrl || logoHeader" alt="" class="talentsListLiImg">
                        <span class="talentsRight">
                            <span class="talentsListLiName">{{item.name | userName}}</span>
                            <span class="talentsListLiNum"><span v-if="item.birthday">{{item.birthday | age}}岁 | </span>{{item.sex}}<span v-if="item.education">｜{{item.education}}</span></span>
                        </span>
                    </li>
                </ul>
                <div class="seeMore moreBottom" v-if="userSeeMore" @click="userMoreCom">查看更多</div>
            </div>
        </div>
        
        <footerPages :backColor="'#3A3D53'" :borderBottom="'1px solid #626475'"></footerPages>
        <div class="jobDetail" @touchmove.prevent v-if="jobDetailTrue">
            <div class="maskLayer" @click="maskClick"></div>
            <div class="jobDetailCont" :style="'height:'+(screenHeight-120)+'px;'">
                <div class="jobDetailHead">
                    <div class="jobDetailHeadLeft">
                        <span class="comTitle">{{jobDetailData.factoryAbbreviationName}}</span>
                        <span class="jobTitle">{{jobDetailData.jobName}}</span>
                        <span class="moneyRule" v-if="jobDetailData.userHourSalary">{{jobDetailData.userHourSalary}}元/小时</span>
                        <span class="moneyRule" v-else>{{jobDetailData.userMinSalary}}-{{jobDetailData.userMaxSalary}}元/月</span>
                        <div class="ageRule">男{{jobDetailData.userManAgeMin}}～{{jobDetailData.userManAgeMax}}岁｜女{{jobDetailData.userWomanAgeMin}}～{{jobDetailData.userWomanAgeMax}}岁</div>
                        <div class="walfeLabel">
                            <span v-for="(label,index) in jobDetailData.welfareTag" :key="index">
                               {{label}}、
                           </span>
                        </div>
                    </div>
                    <div class="jobDetailHeadRight">
                        <img :src="'data:image/png;base64,'+jobCodeImg" alt="" class="img" v-if="jobCodeImg">
                        <span class="img" v-else>
                            <img :src="loadingImg" alt="" class="img" style="width:32px;height:32px;">
                        </span>
                        <span>扫码报名</span>
                    </div>
                </div>
                <div class="workAddress" v-if="jobDetailData.provinces">
                    <span class="workAddressTitle">工作地点</span>
                    <span class="workAddressDetail">{{jobDetailData.provinces.replace(/\s+/g,"")}}{{jobDetailData.address}}</span>
                </div>
                <div class="jobDescription">
                    <div class="jobDesTitle">职位描述</div>
                    <!-- 我的收入 -->
                    <div class="desList" v-if="jobDetailData.userConsolidatedIncome || jobDetailData.userSalaryStandard || jobDetailData.userGrantSalaryType || jobDetailData.userGrantSalaryTime || jobDetailData.userSalaryConstitute || jobDetailData.userSalaryConstitute || jobDetailData.userRatepayingExplain">
                    <div class="desListLabel">我的收入</div>
                    <div class="desListDev" v-if="jobDetailData.userConsolidatedIncome">
                        <div class="desListDevLeft">综合收入</div>
                        <div class="desListDevRight">{{jobDetailData.userConsolidatedIncome}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userSalaryStandard">
                        <div class="desListDevLeft">薪资标准</div>
                        <div class="desListDevRight">{{jobDetailData.userSalaryStandard}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userGrantSalaryType">
                        <div class="desListDevLeft">发薪方式</div>
                        <div class="desListDevRight" v-if="jobDetailData.userGrantSalaryType==0">按月</div>
                        <div class="desListDevRight" v-if="jobDetailData.userGrantSalaryType==1">按周</div>
                        <div class="desListDevRight" v-if="jobDetailData.userGrantSalaryType==2">按日</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userGrantSalaryTime">
                        <div class="desListDevLeft">发薪日</div>
                        <div class="desListDevRight">{{jobDetailData.userGrantSalaryTime}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userSalaryConstitute">
                        <div class="desListDevLeft">薪资结构</div>
                        <div class="desListDevRight">{{jobDetailData.userSalaryConstitute}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userRatepayingExplain">
                        <div class="desListDevLeft">纳税说明</div>
                        <div class="desListDevRight">{{jobDetailData.userRatepayingExplain}}</div>
                    </div>
                    </div>
                    <!-- 我的福利 -->
                    <div class="desList" v-if="jobDetailData.userMealsExplain || jobDetailData.userResidenceExplain || jobDetailData.userInsuranceExplain || jobDetailData.userElseWelfare">
                    <div class="desListLabel">我的福利</div>
                    <div class="desListDev" v-if="jobDetailData.userMealsExplain">
                        <div class="desListDevLeft">伙食情况</div>
                        <div class="desListDevRight">{{jobDetailData.userMealsExplain}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userResidenceExplain">
                        <div class="desListDevLeft">住宿情况</div>
                        <div class="desListDevRight">{{jobDetailData.userResidenceExplain}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userInsuranceExplain">
                        <div class="desListDevLeft">保险情况</div>
                        <div class="desListDevRight">{{jobDetailData.userInsuranceExplain}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userElseWelfare">
                        <div class="desListDevLeft">其他福利</div>
                        <div class="desListDevRight">{{jobDetailData.userElseWelfare}}</div>
                    </div>
                    </div>
                    <!-- 我的工作 -->
                    <div class="desList"  v-if="jobDetailData.userWorkContent || jobDetailData.userWorkTime || jobDetailData.userWorkType || jobDetailData.userWorkArea">
                    <div class="desListLabel">我的工作</div>
                    <div class="desListDev" v-if="jobDetailData.userWorkContent">
                        <div class="desListDevLeft">工作内容</div>
                        <div class="desListDevRight">{{jobDetailData.userWorkContent}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userWorkTime">
                        <div class="desListDevLeft">工作时间</div>
                        <div class="desListDevRight">{{jobDetailData.userWorkTime}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userWorkType">
                        <div class="desListDevLeft">工作方式</div>
                        <div class="desListDevRight">{{jobDetailData.userWorkType}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userWorkArea">
                        <div class="desListDevLeft">工作区域</div>
                        <div class="desListDevRight">{{jobDetailData.userWorkArea}}</div>
                    </div>
                    </div>
                    <!-- 录用条件 -->
                    <div class="desList" v-if="jobDetailData.userManAgeMin || jobDetailData.userEducationRequire || jobDetailData.userAreaRequire || jobDetailData.userElseRequire">
                    <div class="desListLabel">录用条件</div>
                    <div class="desListDev" v-if="jobDetailData.userManAgeMin">
                        <div class="desListDevLeft">性别年龄</div>
                        <div class="desListDevRight">男{{jobDetailData.userManAgeMin}}～{{jobDetailData.userManAgeMax}}周岁；女{{jobDetailData.userWomanAgeMin}}～{{jobDetailData.userWomanAgeMax}}周岁</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userEducationRequire">
                        <div class="desListDevLeft">学历要求</div>
                        <div class="desListDevRight" v-if="jobDetailData.userEducationRequire==0">学历不限</div>
                        <div class="desListDevRight" v-if="jobDetailData.userEducationRequire==1">小学以上</div>
                        <div class="desListDevRight" v-if="jobDetailData.userEducationRequire==2">初中以上</div>
                        <div class="desListDevRight" v-if="jobDetailData.userEducationRequire==3">高中以上</div>
                        <div class="desListDevRight" v-if="jobDetailData.userEducationRequire==4">大专以上</div>
                        <div class="desListDevRight" v-if="jobDetailData.userEducationRequire==5">本科以上</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userAreaRequire">
                        <div class="desListDevLeft">地域要求</div>
                        <div class="desListDevRight">{{jobDetailData.userAreaRequire}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userElseRequire">
                        <div class="desListDevLeft">其他要求</div>
                        <div class="desListDevRight">{{jobDetailData.userElseRequire}}</div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 入驻弹窗 -->
        <div class="enterWindow" v-if="maskTrue">
            <div class="maskBack"></div>
            <div class="writeCont">
                <div class="writeTitle">填写资料，立即入驻</div>
                <div class="writeContBorder">
                    <div class="selectAndInput">
                        <label for="" class="labelName">我的身份</label>
                        <div class="boxTab">
                            <span v-for="(items,index) in tabs" :key="index" :class="curentIdent==index? 'activeIdentity identity':'identity'" @click="tabIdentity(index)">{{items}}</span>
                        </div>
                    </div>
                    <div class="selectAndInput phoneInput">
                        <label for="" class="labelName">我的姓名</label>
                        <input type="text" minlength="1" maxlength="6" placeholder="请输入" v-model="form.name">
                    </div>
                    <div class="selectAndInput phoneInput">
                        <label for="" class="labelName">联系方式</label>
                        <input  :class="phoneNumberStyle==true ? 'activeColor':''" type="number" placeholder="请输入手机号" oninput="if(value.length > 11)value = value.slice(0, 11)" v-model="form.phone">
                    </div>
                    <div class="wantSay">
                        <label for="" class="labelName">想说的话</label>
                        <textarea name="" v-model="form.applyReason" id="" cols="30" maxlength="200" placeholder="请填写您想和我们说的话" rows="10"></textarea>
                        <span>{{form.applyReason.length}}/200</span>
                    </div>
                    <div class="submit">
                        <div @click="submit" :disabled="!loading" :class="canSubmit==true ? 'btn-active':''">提  交</div>
                    </div>  
                </div>
                <span class="closeImg" @click="closeMask">
                    <img :src="closeImg" alt="">
                </span>
            </div>
        </div>
        <div class="taskShade" v-if="centerTaskTrue">
            <div class="centerTask">
                <p>提示</p>
                <span>{{testMessage}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import {WOW} from 'wowjs'
import haojobLogo from '@/assets/haoojoblogo.svg'
import contactus from '@/assets/download/contactus-map@2x.png'
import locationImg from '@/assets/location@2x.png'
import headTitBg from '@/assets/headTitBg.png'
import headLogoBg from '@/assets/headLogoBg.png'
import logoHeader from '@/assets/logoHeader.png'
import closeImg from '@/assets/close@3x.png'
import loadingImg from '@/assets/loadingImg.gif'

import api from '@/api'

export default {
    data(){
        return {
            loadingImg,
            screenHeight: 0,
            appTrueActive:false,
            closeImg,
            logoHeader,
            testMessage:'客服将在1～3个工作日内联系您，请您保持电话畅通',
            centerTaskTrue:false,
            curentIdent:0,
            maskTrue:false,
            typeName:'请选择',
            loading:true,
            tabs: ['劳务公司','招聘门店','招聘专员'],
            form:{
                type:'',
                name:'',
                phone:'',
                applyReason:'',
                sourceType:2,
            },

            headLogoBg,
            headTitBg,
            haojobLogo,
            contactus,
            locationImg,
            jobList: [],//职位列表
            jobListTrue:false,
            jobDetailData: [],//职位详情
            jobDetailTrue:false,
            companyList: [],//优质企业
            comSeeMore:false,
            query:{
                pageNum:1,
                pageSize:9,
                jobStatus:0,
            },
            comQuery:{
                pageNum:1,
                pageSize:10,
            },
            groupQuery:{
                pageNum:1,
                pageSize:12,
            },
            groupSeeMore:false,
            groupWebList:[],//城市合伙人数据
            groupTotalPages:'',

            userSeeMore:false,
            userList:[],
            userTotalPages:'',
            userQuery:{
                pageNum:1,
                pageSize:12,
                isSelectStoreroom:0,
            },

            comTotalPages:'',
            jobTotalPages:'',
            jobCodeImg:'',
            
        }
    },
    computed:{
        // 用于校验手机号码格式是否正确
        phoneNumberStyle(){
            let reg = /^1[3456789]\d{9}$/
            if(!reg.test(this.form.phone)){
                return false
            }
            return true
        },
        canSubmit(){
            console.log(11,this.form.type,this.form.name,this.phoneNumberStyle)
            if(this.phoneNumberStyle && this.form.name){
                return true
            }else{
                return false
            }
        },
    },
    methods:{
        appDownload(){//移入App下载
            this.appTrueActive=true
        },
        leaveDownload(){
            this.appTrueActive=false
        },
        goHome(){
            this.$router.push('/')
        },
        goSelectCity(){
            this.$router.push(`/selectCity`)
        },
        tabIdentity(index){
            this.curentIdent=index
        },
        goEnter(){
            this.maskTrue=true
        },
        closeMask(){
            this.maskTrue=false
        },
        async submit(){
            let that = this
            if(this.curentIdent==0){
                this.form.type=3
            }else if(this.curentIdent==1){
                this.form.type=1
            }else if(this.curentIdent==2){
                this.form.type=0
            }
            this.loading=true
            if(this.canSubmit&&this.loading){
                this.loading=false
                let res = await api.roleApplySave(this.form)
                if(res.code==200){
                    this.maskTrue=false
                    that.centerTaskTrue=true
                    setTimeout(function(){
                        that.centerTaskTrue=false
                    },3000)
                }else{
                    this.maskTrue=false
                    that.centerTaskTrue=true
                    setTimeout(function(){
                        that.centerTaskTrue=false
                    },3000)
                    this.testMessage=res.message
                }
                console.log(res)
            }
        },
        goLabourDetail(data){//跳转劳务公司主页
            this.$router.push(`/labourDetail`)
            localStorage.setItem('labourDetail',JSON.stringify(data))
        },
        userMoreCom(){//查看更多城市合伙人
            this.userQuery.pageNum+=1
            this.getUserData()
        },
        groupMoreCom(){//查看更多城市合伙人
            this.groupQuery.pageNum+=1
            this.getGroupData()
        },
        seeMoreCom(){//查看更多企业
            this.comQuery.pageNum+=1
            this.getCompanyData()
        },
        seeMoreJob(){//查看更多职位
            this.query.pageNum+=1
            this.initData()
        },
        async jobShowDetail(id){
            this.jobCodeImg= ''
            // 获取职位详情
            let query = {
                jobId:id
            }
            this.jobDetailTrue = true
            let res = await api.jobInfo(query)
            res.welfareTag=JSON.parse(res.welfareTag)
            this.jobDetailData = res
            let newdata = {
                userId:'',
                jobId:id
            }
            // 获取职位二维码
            let codeQuery = {
                info: JSON.stringify(newdata),
                url:'pages/findJob/jobDetail/index'
            }
            this.jobCodeImg = await api.jobCode(codeQuery)
        },
        addressCity (sum) {
            if(sum){
                let city = sum.split(" ")[1]
                if(city==="市辖区" || city==="县"){
                    return sum.split(" ")[0]
                }
                return city
            }else {
                return ''
            }
        },
        maskClick(){
            this.jobDetailTrue=false
        },
        async getGroupData(){//获取城市合伙人
            let res = await api.groupWebList(this.groupQuery)
            let obj = res.content
            this.groupTotalPages = res.totalPages
            for(let i in obj){
                obj[i].cityName = obj[i].provinces.split(' ')[1]
            }
            console.log('obj',obj)
            if(res.totalSize>10){//如果数据有10条以上，才显示公司更多按钮
                this.groupSeeMore=true
            }else{
                this.groupSeeMore=false
            }
            if(this.groupTotalPages==this.groupQuery.pageNum){//处理隐藏显示更多用工单位
                this.groupSeeMore = false
            }
            
            this.groupWebList = this.groupWebList.concat(obj)
        },
        async getUserData(){//获取人才列表
            let res = await api.userList(this.userQuery)
            let obj = res.content
            for(let i=0;i<obj.length;i++){
                // 类型
                if(obj[i].education==0){
                    obj[i].education='小学'
                }else if(obj[i].education==1){
                    obj[i].education='初中'
                }else if(obj[i].education==2){
                    obj[i].education='高中'
                }else if(obj[i].education==3){
                    obj[i].education='大专'
                }else if(obj[i].education==4){
                    obj[i].education='本科'
                }else if(obj[i].education==5){
                    obj[i].education='硕士'
                }else if(obj[i].education==6){
                    obj[i].education='博士'
                }
                if(obj[i].sex==0){
                    obj[i].sex='男'
                }else if(obj[i].sex==1){
                    obj[i].sex='女'
                }
            }
            this.userTotalPages = res.totalPages
            if(res.totalSize>12){//如果数据有10条以上，才显示公司更多按钮
                this.userSeeMore=true
            }else{
                this.userSeeMore=false
            }
            if(this.userTotalPages==this.userQuery.pageNum){//处理隐藏显示更多用工单位
                this.userTotalPages = false
            }
            
            this.userList = this.userList.concat(obj)
        },
        async getCompanyData(){
            let res = await api.companyList(this.comQuery)
            this.comTotalPages = res.totalPages
            if(res.totalSize>10){//如果数据有10条以上，才显示公司更多按钮
                this.comSeeMore=true
            }else{
                this.comSeeMore=false
            }
            if(this.comTotalPages==this.comQuery.pageNum){//处理隐藏显示更多用工单位
                this.comSeeMore = false
            }
            let obj = res.content
            for(let i=0;i<obj.length;i++){
                // 类型
                if(obj[i].status==0){
                    obj[i].status='民营'
                }else if(obj[i].status==1){
                    obj[i].status='外资'
                }else if(obj[i].status==2){
                    obj[i].status='合资'
                }else if(obj[i].status==3){
                    obj[i].status='国企'
                }else if(obj[i].status==4){
                    obj[i].status='政府机关'
                }else if(obj[i].status==5){
                    obj[i].status='事业单位'
                }else if(obj[i].status==6){
                    obj[i].status='股份制公司'
                }else if(obj[i].status==7){
                    obj[i].status='上市公司'
                }else if(obj[i].status==8){
                    obj[i].status='创业公司'
                }else if(obj[i].status==9){
                    obj[i].status='其他'
                }
                // 规模
                if(obj[i].scale==0){
                    obj[i].scale='少于15人'
                }else if(obj[i].scale==1){
                    obj[i].scale='16-50人'
                }else if(obj[i].scale==2){
                    obj[i].scale='51-150人'
                }else if(obj[i].scale==3){
                    obj[i].scale='151-500人'
                }else if(obj[i].scale==4){
                    obj[i].scale='501-2000人'
                }else if(obj[i].scale==5){
                    obj[i].scale='2000人以上'
                }
                
            }
            this.companyList = this.companyList.concat(obj)
        },
        async initData(){
            let res = await api.jobList(this.query)
            console.log(res.totalPages)
            this.jobTotalPages = res.totalPages
            if(res.totalSize>9){//如果数据有9条以上，才显示职位更多按钮
                this.jobListTrue=true
            }else{
                this.jobListTrue=false
            }
            if(this.jobTotalPages==this.query.pageNum){//处理隐藏显示更多用工单位
                this.jobListTrue = false
            }
            let obj = res.content
            for(let i in obj){
                if(obj[i].jobType==0){
                    obj[i].jobType='普工'
                }else if(obj[i].jobType==1){
                    obj[i].jobType='技工'
                }else if(obj[i].jobType==2){
                    obj[i].jobType='实习工'
                }
            }
            this.jobList = this.jobList.concat(obj)
        }
    },
    mounted () {
        let wow = new WOW({
                boxClass: 'wow',
                animateClass: 'animated',
                offset: 0,
                mobile: true
        })
        wow.init();
    },
    created(){
        this.initData()
        this.getCompanyData()
        this.getGroupData()
        this.getUserData()
    }
}
</script>
<style src='@/pages/components/publicStyle/animated.css' scoped></style>
<style scoped lang="less">
    .haojobImg{
        float: left;
        margin-right: 20px;
    }
    .selectCity{
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        line-height: 40px;
        margin-top:20px;
        cursor: pointer;
        float: left;
    }
    .jobDetail{
        width: 100%;
        min-width: 1200px;
        height: 100%;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1000;
        justify-content: center;
        display: flex;
        align-items: center;
        
        .maskLayer{
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 900;
            background:rgba(0, 0, 0, 0.4);
        }
        .jobDetailCont{
            width: 1000px;
            min-width: 1000px;
            height: auto;
            overflow-y: scroll;
            margin: 0 auto;
            background: #fff;
            position: relative;
            z-index: 1001;
            overflow-x: hidden;
            position: fixed;
            top: 60px;
            bottom: 60px;
            .jobDetailHead{
                width: 100%;
                height: auto;
                background: #F1F6FF;
                overflow: hidden;
                padding: 50px 80px 50px 80px;
                box-sizing: border-box;
                .jobDetailHeadLeft{
                    float: left;
                    .comTitle{
                        display: block;
                        font-size: 18px;
                        color: #666;
                    }
                    .jobTitle{
                        width: 620px;
                        font-size: 36px;
                        color: #222;
                        display: block;
                        line-height: 50px;
                        margin-top: 10px;
                    }
                    .moneyRule{
                        font-size: 24px;
                        color: #F97F27;
                        display: block;
                        line-height: 32px;
                        margin-top: 5px;
                    }
                    .ageRule{
                        font-size: 18px;
                        color: #666666;
                        display: block;
                        line-height: 24px;
                        margin-top: 20px;
                    }
                    .walfeLabel{
                        font-size: 16px;
                        color: #999;
                        display: block;
                        margin-top: 10px;
                    }
                }
                .jobDetailHeadRight{
                    float: right;
                    width: 170px;
                    height: auto;
                    overflow: hidden;
                    margin-bottom: 20px;
                    .img{
                        width: 170px;
                        height: 170px;
                        display: flex;
                        background: #fff;
                        justify-content: center;
                        align-items: center;
                    }
                    span{
                        text-align: center;
                        display: block;
                        line-height: 58px;
                        font-size: 18px;
                        color: #222222;
                    }
                }
            }
            .workAddress{
                padding: 0 80px;
                width: 100%;
                height: auto;
                overflow: hidden;
                margin-top: 46px;
                .workAddressTitle{
                    font-size: 28px;
                    color: #333333;
                    font-weight: 500;
                    line-height: 32px;
                    display: block;
                }
                .workAddressDetail{
                    display: block;
                    font-size: 16px;
                    color: #666666;
                    line-height: 46px;
                    margin-top: 1px;
                    margin-bottom: 30px;
                }
            }
            .jobDescription{
                padding: 0 80px;
                box-sizing: border-box;
                overflow: hidden;
                height: auto;
                margin-bottom: 80px;
                .jobDesTitle{
                    font-weight: 500;
                    font-size: 22px;
                    margin-bottom: 20px;
                }
                .desList{
                    width: 100%;
                    height: auto;
                    overflow: hidden;
                    border: 1px solid rgba(187, 188, 204, 1);
                    border-top: 0;
                    box-sizing: border-box;
                    .desListLabel{
                        width: 99.9%;
                        height: 50px;
                        line-height: 50px;
                        background: #F2F6FF;
                        padding: 0 40px;
                        box-sizing: border-box;
                        font-size: 18px;
                        color: #1D5EEA;
                    }
                    .desListDev{
                        width: 100%;
                        height: auto;
                        overflow: hidden;
                        border-top: 1px solid rgba(187, 188, 204, 1);
                        box-sizing: border-box;
                        .desListDevLeft{
                            width: 128px;
                            float: left;
                            font-size: 16px;
                            padding: 23px 0;
                            padding-right: 40px;
                            color: #333333;
                            box-sizing: border-box;
                            text-align: right;
                        }
                        .desListDevRight{
                            width: 691px;
                            float: left;
                            border-left: 1px solid rgba(187, 188, 204, 1);
                            box-sizing: border-box;
                            font-size: 16px;
                            padding: 23px;
                            color: #565566;
                            line-height: 24px;
                            height: auto;
                            overflow: hidden;
                        }
                    }
                }
                .desList:nth-child(2){
                    border-top: 1px solid rgba(187, 188, 204, 1);
                }
            }
        }
    }
    .taskShade{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        justify-content: center;
        align-items: center;
        display: flex;
        z-index: 1000;
    }
    .centerTask{
        width: 450px;
        background: rgba(0,0,0,.6);
        border-radius: 10px;
        display: flex;
        align-content: center;
        flex-wrap: wrap;
        justify-content: space-around;
        padding: 30px;
    }
    .centerTask>p{
        width: 100%;
        text-align: center;
        font-size: 30px;
        line-height: 46px;
        color: #fff;
        margin-top: 15px;
        margin-bottom: 19px;
    }
    .centerTask>span{
        color: #fff;
        font-size: 26px;
        line-height: 40px;
        text-align: center;
        display: block;
    }
    .enterWindow{
        width: 100%;
        height: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 10000;
        justify-content: center;
        align-items: center;
        display: flex;
        .maskBack{
            background: rgba(0, 0, 0, 0.4);
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 99;    
        }
        .writeCont{
            width: 700px;
            max-width: 700px;
            background: #fff;
            position: relative;
            overflow-y: auto;
            z-index: 100;
            padding: 60px 80px;
            box-sizing: border-box;
            position: fixed;
            top: 60px;
            bottom: 60px;
            .writeTitle{
                width: 100%;
                font-size: 30px;
                font-weight: 500;
                color: #222222;
                line-height: 76px;
            }
            .writeContBorder{
                width: 100%;
                height: auto;
                overflow: hidden;
                margin-top: 30px;
                .selectAndInput{
                    width: 100%;
                    height: 50px;
                    line-height: 50px;
                    margin-top: 20px;
                    .boxTab{
                        width: 450px;
                        height: 50px;
                        line-height: 50px;
                        overflow: hidden;
                        float: right;
                        .identity{
                            width: 33.3%;
                            cursor: pointer;
                            height: 50px;
                            text-align: center;
                            float: left;
                            border: 1px solid #CCCCCC;
                            box-sizing: border-box;
                        }
                        .identity:nth-child(2),.identity:nth-child(1){
                            border-right: 0;
                        }
                        .activeIdentity{
                            background: #1D5EEA;
                            color: #fff;
                        }
                    }
                    .labelName{
                        font-size: 18px;
                        font-weight: 400;
                        color: #333333;
                        line-height: 50px;
                        float: left;
                    }
                    input{
                        width: 450px;
                        height: 50px;
                        float: right;
                        font-size: 18px;
                        color: #333;
                        padding: 0 19px;
                        box-sizing: border-box;
                        overflow: hidden;
                        border: 1px solid #ccc;
                        outline: none;
                    }
                    input::placeholder{
                        color: #CCCCCC;
                    }
                }
                .wantSay{
                    margin-top: 20px;
                    overflow: hidden;
                    position: relative;
                    span{   
                        font-size: 18px;
                        font-weight: 500;
                        color: #CCCCCC;
                        position: absolute;
                        bottom: 15px;
                        right: 15px;
                    }
                    .labelName{
                        font-size: 18px;
                        font-weight: 400;
                        color: #333333;
                        line-height: 50px;
                        float: left;
                    }
                    textarea{
                        float: right;
                        width: 450px;
                        font-size: 18px;
                        height: 200px;
                        border: 1px solid #ccc;
                        padding: 20px;
                        box-sizing: border-box;
                        line-height: 30px;
                        resize:none;
                        outline: none;
                    }
                }
                .submit{
                    div{
                        width: 450px;
                        height: 56px;
                        background: #1D5EEA;
                        font-size: 20px;
                        font-weight: 500;
                        color: #FFFFFF;
                        text-align: center;
                        line-height: 56px;
                        float: right;
                        margin-top: 32px;
                        cursor: pointer;
                        opacity: 0.3;
                    }
                    .btn-active{
                        opacity: 1;
                    }
                }
            }
            .closeImg{
                width: 40px;
                height: 40px;
                display: block;
                position: absolute;
                right: 0;
                top: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                img{
                    width: 15px;
                    height: 15px;
                    display: block;
                }
            }
        }
        .successWindow{
            height: 351px;
        }
    }
    .centerFloat{
        width: 100%;
        height: auto;
        overflow: hidden;
        box-sizing: border-box;
        .header{
            width: 100%;
            height: 500px;
            background: #1D5EEA;
            .headerCont{
                width: 1200px;
                height: 500px;
                box-sizing: border-box;
                overflow: hidden;
                margin: 0 auto;
                position: relative;
                .headTitBg{
                    width: 719px;
                    height: 69px;
                    margin-top: 116px;
                }
                .headLogoBg{
                    width: 297px;
                    height: 500px;
                    position: absolute;
                    right: 0;
                    top: 0;
                    z-index: 10;
                }
                .preempt{
                    font-size: 26px;
                    color: #fff;
                    margin-top: 15px;
                    line-height: 60px;
                    font-weight: 500;
                }
                .atOnce{
                    width: 400px;
                    height: 80px;
                    line-height: 80px;
                    text-align: center;
                    color: #1D5EEA;
                    font-weight: 500;
                    display: block;
                    font-size: 32px;
                    background: #fff;
                    margin-top: 42px;
                    cursor: pointer;
                }
            }
        }
        .textCont{
            width: 1200px;
            height: auto;
            box-sizing: border-box;
            overflow: hidden;
            margin: 0 auto;
            .hotJobTit{
                width: fit-content;
                height: 40px;
                overflow: hidden;
                margin: 0 auto;
                margin-bottom: 22px;
                margin-top: 62px;
                span{
                    width: 100px;
                    height: 1px;
                    display: block;
                    background: #CCCCCC;
                    float: left;
                    margin-top: 20px;
                }
                p{
                    font-size: 24px;
                    color: #333333;
                    line-height: 40px;
                    font-weight: 400;
                    float: left;
                    margin: 0 20px;
                }
            }
            .jobList{
                width: 100%;
                height: auto;
                overflow: hidden;
                .jobListLi{
                    width: 390px;
                    height: 191px;
                    background: #fff;
                    padding: 30px;
                    box-sizing: border-box;
                    cursor: pointer;
                    float: left;
                    margin-right: 15px;
                    margin-bottom: 30px;
                    border: 1px solid rgba(204, 204, 204, 0.3);
                    .jobListLiHead{
                        width: 100%;
                        line-height: 20px;
                        font-size: 18px;
                        font-weight: 400;
                        overflow: hidden;
                        .jobListLiHeadTitle{
                            width: 140px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            color: #222;
                            float: left;
                        }
                        .jobListLiHeadMoney{
                            color: #F97F27;
                            float: right;
                        }
                    }
                    .jobLiAge{
                        font-size: 14px;
                        color: #666;
                        margin: 14px 0;
                        width: 100%;
                    }
                    .jobLiLabel{
                        width: 100%;
                        overflow: hidden;
                        height: 30px;
                        span{
                            padding: 0 10px;
                            line-height: 28px;
                            box-sizing: border-box;
                            background: rgba(28, 129, 255, 0);
                            border: 1px solid #E5E5E5;
                            border-radius: 2px;
                            font-size: 12px;
                            color: #999999;
                            text-align: center;
                            float: left;
                            margin-right: 10px;
                        }
                    }
                    .jobLiFoot{
                        width: 100%;
                        display: block;
                        border-top: 1px dashed #E5E5E5;
                        box-sizing: border-box;
                        padding-top: 10px;
                        margin-top: 15px;
                        .jobLiCom{
                            color: #333333;
                            font-size: 14px;
                            font-weight: 400;
                            line-height: 14px;
                            padding-right: 13px;
                            border-right: 1px solid #E5E5E5;
                            float: left;
                            box-sizing: border-box;
                        }
                        .jobLiLoca{
                            width: 12px;
                            height: 14px;
                            float: left;
                            margin-left: 10px;
                            margin-right: 5px;
                        }
                        .jobLiCity{
                            font-size: 14px;
                            color: #999999;
                            float: left;
                            line-height: 14px;
                        }
                    }
                }
                .jobListLi:nth-child(3n){
                    margin-right: 0;
                }
            }
            .companyList{
                width: 100%;
                height: auto;
                overflow: hidden;
                .companyListLi{
                    width: 224px;
                    height: 208px;
                    background: #fff;
                    padding: 30px;
                    margin-right: 20px;
                    margin-bottom: 32px;
                    box-sizing: border-box;
                    float: left;
                    overflow: hidden;
                    border: 1px solid rgba(204, 204, 204, 0.3);
                    .companyListLiImg{
                        width: 90px;
                        height: 90px;
                        border: 1px solid #E3E3E3;
                        margin: 0 auto;
                        display: block;
                    }
                    .companyListLiName{
                        font-size: 18px;
                        color: #333333;
                        text-align: center;
                        display: block;
                        line-height: 37px;
                        margin-top: 10px;
                    }
                    .companyListLiNum{
                        font-size: 14px;
                        color: #999999;
                        text-align: center;
                        display: block;
                        line-height: 16px;
                    }
                }
                .companyListLi:nth-child(5n){
                    margin-right: 0;
                }
            }
            .partnerList{
                width: 100%;
                height: auto;
                overflow: hidden;
                .partnerListLi{
                    width: 280px;
                    height: 300px;
                    overflow: hidden;
                    background: #fff;
                    margin-right: 26px;
                    cursor: pointer;
                    padding: 30px 0;
                    border: 1px solid rgba(204, 204, 204, 0.5);
                    box-sizing: border-box;
                    float: left;
                    margin-bottom: 30px;
                    .partnerListLiImg{
                        width: 80px;
                        height: 80px;
                        display: block;
                        margin: 0 auto;
                    }
                    .partnerOne{
                        font-size: 18px;
                        font-weight: 400;
                        color: #333333;
                        display: block;
                        text-align: center;
                        line-height: 24px;
                        margin-top: 15px;
                    }
                    .partnerTwo{
                        display: block;
                        text-align: center;
                        font-size: 14px;
                        font-weight: 400;
                        color: #333333;
                        line-height: 20px;
                        margin-top: 5px;
                    }
                    .partnerThree{
                        display: block;
                        text-align: center;
                        font-size: 14px;
                        font-weight: 400;
                        color: #1D5EEA;
                        line-height: 20px;
                        margin-top: 5px;
                    }
                    .partnerFour{
                        width: 100%;
                        height: 44px;
                        display: block;
                        margin-top: 25px;
                        .numLi{
                            width: 33%;
                            border-right: 1px dashed #CCCCCC;
                            box-sizing: border-box;
                            float: left;
                            display: block;
                            height: 44px;
                            span:first-child{
                                font-size: 20px;
                                font-weight: 400;
                                color: #333333;
                                line-height: 24px;
                                display: block;
                                text-align: center;
                            }
                            span:last-child{
                                font-size: 14px;
                                display: block;
                                text-align: center;
                                font-weight: 400;
                                color: #999999;
                                line-height: 24px;
                            }
                        }
                        .numLi:last-child{
                            border-right: 0;
                        }
                    }
                }
                .partnerListLi:nth-child(4n){
                    margin-right: 0;
                }
            }
            .talentsList{
                width: 100%;
                height: auto;
                overflow: hidden;
                .talentsListLi{
                    width: 280px;
                    height: 130px;
                    background: #FFFEFF;
                    float: left;
                    border: 1px solid rgba(204, 204, 204, 0.5);
                    overflow: hidden;
                    float: left;
                    margin-right: 25px;
                    box-sizing: border-box;
                    margin-bottom: 30px;
                    padding: 30px;
                    .talentsListLiImg{
                        width: 70px;
                        height: 70px;
                        border-radius: 50%;
                        display: block;
                        margin-right: 18px;
                        float: left;
                    }
                    .talentsRight{
                        float: left;
                        width: auto;
                        display: block;
                        height: 70px;
                        overflow: hidden;
                        .talentsListLiName{
                            display: block;
                            font-size: 18px;
                            font-weight: 400;
                            line-height: 35px;
                            color: #222222;
                        }
                        .talentsListLiNum{
                            line-height: 35px;
                            display: block;
                            font-size: 14px;
                            font-weight: 400;
                            color: #666666;
                        }
                    }
                }
                .talentsListLi:nth-child(4n){
                    margin-right: 0;
                }
            }
        }
        
        .seeMore{
            width: 300px;
            height:40px;
            font-size:18px;
            font-weight:400;
            color:#fff;
            line-height: 40px;
            text-align: center;
            margin: 0 auto;
            margin-top: 10px;
            cursor: pointer;
            background: #1D5EEA;
            border: 1px solid #1D5EEA;
        }
        .moreBottom{
            margin-bottom: 100px;
        }
    }
    
</style>